import { isValid } from '@/common/utils/validation/common.utils';
import { PromotionDetailsResponse } from '@/core/domain/promotion-details/models/promotion-details.model';
import { PromotionDetailsRepository } from '@/core/domain/promotion-details/repositories/promotion-details.repository';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PromotionDetailsImplRepository extends PromotionDetailsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getPromotionDetails(
        couponCode: string | null = null,
        couponUrl: string | null = null,
    ): Observable<PromotionDetailsResponse> {
        let params = new HttpParams();
        if (isValid(couponCode)) {
            params = params.append('couponCode', couponCode as string);
        }
        if (isValid(couponUrl)) {
            params = params.append('couponUrl', couponUrl as string);
        }
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.promotionDetail,
                ].join('/'),
                {
                    params: params,
                },
            )
            .pipe(
                switchMap(
                    (promotionDetailsResponse: PromotionDetailsResponse) => {
                        const promotionDetails: PromotionDetailsResponse = {
                            type: promotionDetailsResponse.type,
                            action: promotionDetailsResponse.action,
                            notifications:
                                promotionDetailsResponse.notifications,
                            data: promotionDetailsResponse.data,
                        };

                        return of(promotionDetails);
                    },
                ),
            );
    }
}
